<template>
  <div class="MFA">
  </div>
</template>

<script>
  import router from "@/router";
  export default {
    mounted() {
      let state = this.$route.query.state;
      let code = this.$route.query.code;
      let storedState = null;
      let duoState = localStorage.getItem('duoState');
      if (duoState != null) {
        storedState = JSON.parse(duoState);
      }
      if (state != null && code != null && storedState != null) {
        let data = {
          state: state,
          code: code,
          storedState: storedState.duoState,
          storedUserId: storedState.userId
        }
        this.validateMFA(data);
      } else {
        router.push("/login");  //redirect back to login if we don't have any of the duo data
      }

    },
    methods: {
      validateMFA(data) {
        this.$http.post("Auth/MFA", data).then((response) => {
          if (response.status == 200) {
            this.setTokenAndRedirect(response.data);
          } else {
            router.push("/login");
          }
        });
        localStorage.removeItem('duoState');
      },
      async setTokenAndRedirect(jwt) {
        this.$store.commit("setUser", {
          access_token: jwt.access_token,
          expires_in: jwt.expires_in,
          refresh_token: jwt.refresh_token,
        });
        // dispatch check for refresh token
        this.$store.dispatch("autoRefresh");
          router.push("/dashboard");
      },
    }

  }

</script>
